import React from 'react';
import { useTeamModal } from 'contexts/TeamModalContext';
import { UNCANCEL_SUBSCRIPTION } from 'constants/AccountPageConstants';
import BillingModalMainWrapper from './BillingModalMainWrapper';
import { formatSubscriptionEndDate, formatSubscriptionPrice } from '../../../utils/subscriptionUtils';

const SecondParagraph = ({ subscription }) => {
  const status = subscription.status || '';
  const formattedPrice = formatSubscriptionPrice(subscription);
  const interval = subscription.plan?.interval || 'month';
  
  if (status !== 'canceled') {
    return (
      <p>
        Your subscription will end on {formatSubscriptionEndDate(subscription.current_period_end)}. Renew your plan for {formattedPrice}/{interval}.
      </p>
    );
  } else {
    return (
      <p>
        Renew your plan for {formattedPrice}/{interval}.
      </p>
    );
  }
}

const BillingModalMainBillingCanceled = ({ subscription = {} }) => {
  const { navigateToPage } = useTeamModal();
  
  const renewSubscription = () => {
    navigateToPage(UNCANCEL_SUBSCRIPTION);
  };

  return <BillingModalMainWrapper
    subscription={subscription}
    buttonText="Renew Subscription"
    onButtonClick={renewSubscription}
  >
    <SecondParagraph subscription={subscription} />
  </BillingModalMainWrapper>
};

export default BillingModalMainBillingCanceled;
